// extracted by mini-css-extract-plugin
var _1 = "llb7TWD0QP6o_VuqPYiC";
export { _1 as "root" }
